var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOnboarding(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 892.435,
    height: 532.369,
    viewBox: "0 0 892.435 532.369",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Path_8",
    x: 0,
    y: 0,
    width: 892.435,
    height: 532.369,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 8,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_7",
    x: 132.131,
    y: 182.65,
    width: 732.743,
    height: 86.995,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_10",
    x: 132,
    y: 354,
    width: 733,
    height: 141,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-3"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_6",
    x: 132.131,
    y: 155.855,
    width: 732.743,
    height: 41.717,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-4"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-4"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_6-2",
    x: 133.209,
    y: 328.264,
    width: 732.743,
    height: 41.717,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-5"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-5"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_5",
    x: 133.209,
    y: 122.358,
    width: 732.743,
    height: 48.185,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-6"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-6"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_11",
    x: 777.88,
    y: 438.147,
    width: 86.995,
    height: 41.717,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-7"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-7"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_13",
    x: 661.451,
    y: 72.69,
    width: 40.639,
    height: 30.937,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-8"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-8"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_15",
    x: 112,
    y: 1,
    width: 775,
    height: 62,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-9"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-9"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Onboarding",
    transform: "translate(-990 -92)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 990, 92)",
    filter: "url(#Path_8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8-2",
    "data-name": "Path 8",
    d: "M26.951,0H835.484a26.951,26.951,0,0,1,26.951,26.951V475.417a26.951,26.951,0,0,1-26.951,26.951H26.951A26.951,26.951,0,0,1,0,475.417V26.951A26.951,26.951,0,0,1,26.951,0Z",
    transform: "translate(15 7)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2",
    "data-name": "Rectangle 2",
    d: "M25,0h81a0,0,0,0,1,0,0V502a0,0,0,0,1,0,0H25A25,25,0,0,1,0,477V25A25,25,0,0,1,25,0Z",
    transform: "translate(1005 99)",
    fill: "#1c6bfe"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1",
    "data-name": "Ellipse 1",
    cx: 22.5,
    cy: 22.5,
    r: 22.5,
    transform: "translate(1035 148)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Intersection_1",
    "data-name": "Intersection 1",
    d: "M0,27.38a8.908,8.908,0,0,1,8.06-5.111h3.834a12.111,12.111,0,0,0,10.147,0h3.834a8.911,8.911,0,0,1,8.392,5.912A22.64,22.64,0,0,1,0,27.38ZM6.947,10.022A10.021,10.021,0,1,1,16.968,20.042,10.024,10.024,0,0,1,6.947,10.022Z",
    transform: "translate(1040.344 157.159)",
    fill: "#1c6bfe",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("text", {
    id: "Onboarding-2",
    "data-name": "Onboarding",
    transform: "translate(1132.209 181.378)",
    fontSize: 15,
    fontFamily: "Lato-Bold, Lato",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Onboarding")), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 990, 92)",
    filter: "url(#Rectangle_7)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7-2",
    "data-name": "Rectangle 7",
    width: 714.743,
    height: 68.995,
    rx: 3,
    transform: "translate(141.13 188.65)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 990, 92)",
    filter: "url(#Rectangle_10)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10-2",
    "data-name": "Rectangle 10",
    width: 715,
    height: 123,
    rx: 3,
    transform: "translate(141 360)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Workflow",
    transform: "translate(1132.209 206.719)",
    fill: "#1c6bfe",
    fontSize: 8,
    fontFamily: "Lato-Bold, Lato",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Workflow")), /*#__PURE__*/React.createElement("text", {
    id: "Assignments",
    transform: "translate(1190.424 206.719)",
    fill: "#707070",
    fontSize: 8,
    fontFamily: "Lato-Bold, Lato",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Assignments")), /*#__PURE__*/React.createElement("text", {
    id: "Welcomekit.zip",
    transform: "translate(1363.989 294.041)",
    fill: "#707070",
    fontSize: 8,
    fontFamily: "Lato-Bold, Lato",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Welcomekit.zip")), /*#__PURE__*/React.createElement("text", {
    id: "Data_Security.pdf",
    "data-name": "Data Security.pdf",
    transform: "translate(1363.989 466.528)",
    fill: "#707070",
    fontSize: 8,
    fontFamily: "Lato-Bold, Lato",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Data Security.pdf")), /*#__PURE__*/React.createElement("text", {
    id: "abc",
    transform: "translate(1505.212 294.041)",
    fill: "#707070",
    fontSize: 8,
    fontFamily: "Lato-Regular, Lato"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "abc")), /*#__PURE__*/React.createElement("text", {
    id: "abc-2",
    "data-name": "abc",
    transform: "translate(1503.595 465.45)",
    fill: "#707070",
    fontSize: 8,
    fontFamily: "Lato-Bold, Lato",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "abc")), /*#__PURE__*/React.createElement("text", {
    id: "abc-3",
    "data-name": "abc",
    transform: "translate(1593.612 294.041)",
    fill: "#707070",
    fontSize: 8,
    fontFamily: "Lato-Regular, Lato"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "abc")), /*#__PURE__*/React.createElement("text", {
    id: "abc-4",
    "data-name": "abc",
    transform: "translate(1590 468)",
    fill: "#707070",
    fontSize: 9,
    fontFamily: "Lato-Bold, Lato",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "abc")), /*#__PURE__*/React.createElement("text", {
    id: "abc-5",
    "data-name": "abc",
    transform: "translate(1593.612 317.758)",
    fill: "#707070",
    fontSize: 8,
    fontFamily: "Lato-Regular, Lato"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "abc")), /*#__PURE__*/React.createElement("text", {
    id: "abc-6",
    "data-name": "abc",
    transform: "translate(1593.612 339.318)",
    fill: "#707070",
    fontSize: 8,
    fontFamily: "Lato-Regular, Lato"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "abc")), /*#__PURE__*/React.createElement("text", {
    id: "_08_03_23",
    "data-name": "08/03/23",
    transform: "translate(1662.607 294.041)",
    fill: "#707070",
    fontSize: 8,
    fontFamily: "Lato-Regular, Lato"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "08/03/23")), /*#__PURE__*/React.createElement("text", {
    id: "_08_03_23-2",
    "data-name": "08/03/23",
    transform: "translate(1664.763 465.45)",
    fill: "#707070",
    fontSize: 8,
    fontFamily: "Lato-Bold, Lato",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "08/03/23")), /*#__PURE__*/React.createElement("text", {
    id: "_08_03_23-3",
    "data-name": "08/03/23",
    transform: "translate(1662.607 317.758)",
    fill: "#707070",
    fontSize: 8,
    fontFamily: "Lato-Regular, Lato"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "08/03/23")), /*#__PURE__*/React.createElement("text", {
    id: "_08_03_23-4",
    "data-name": "08/03/23",
    transform: "translate(1662.607 339.318)",
    fill: "#707070",
    fontSize: 8,
    fontFamily: "Lato-Regular, Lato"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "08/03/23")), /*#__PURE__*/React.createElement("text", {
    id: "abc-7",
    "data-name": "abc",
    transform: "translate(1505.212 317.758)",
    fill: "#707070",
    fontSize: 8,
    fontFamily: "Lato-Regular, Lato"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "abc")), /*#__PURE__*/React.createElement("text", {
    id: "abc-8",
    "data-name": "abc",
    transform: "translate(1505.212 339.318)",
    fill: "#707070",
    fontSize: 8,
    fontFamily: "Lato-Regular, Lato"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "abc")), /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    "data-name": "Group 4",
    transform: "translate(1131.131 255.855)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -141.13, -163.86)",
    filter: "url(#Rectangle_6)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6-3",
    "data-name": "Rectangle 6",
    width: 714.743,
    height: 23.717,
    rx: 3,
    transform: "translate(141.13 163.86)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Task",
    transform: "translate(22.639 15.546)",
    fill: "#030303",
    fontSize: 8,
    fontFamily: "Lato-Bold, Lato",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Task")), /*#__PURE__*/React.createElement("text", {
    id: "Type",
    transform: "translate(184.346 15.546)",
    fill: "#030303",
    fontSize: 8,
    fontFamily: "Lato-Bold, Lato",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Type")), /*#__PURE__*/React.createElement("text", {
    id: "Document_Name",
    "data-name": "Document Name",
    transform: "translate(231.779 15.546)",
    fill: "#030303",
    fontSize: 8,
    fontFamily: "Lato-Bold, Lato",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Document Name")), /*#__PURE__*/React.createElement("text", {
    id: "Assigned_To",
    "data-name": "Assigned To",
    transform: "translate(356.833 15.546)",
    fill: "#030303",
    fontSize: 8,
    fontFamily: "Lato-Bold, Lato",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Assigned To")), /*#__PURE__*/React.createElement("text", {
    id: "Name_of_Employee",
    "data-name": "Name of Employee",
    transform: "translate(431.218 15.546)",
    fill: "#030303",
    fontSize: 8,
    fontFamily: "Lato-Bold, Lato",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Name of Employee")), /*#__PURE__*/React.createElement("text", {
    id: "Due_Date",
    "data-name": "Due Date",
    transform: "translate(530.398 15.546)",
    fill: "#030303",
    fontSize: 8,
    fontFamily: "Lato-Bold, Lato",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Due Date")), /*#__PURE__*/React.createElement("text", {
    id: "Action",
    transform: "translate(610.173 15.546)",
    fill: "#030303",
    fontSize: 8,
    fontFamily: "Lato-Bold, Lato",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Action"))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5",
    "data-name": "Group 5",
    transform: "translate(1132.209 427.264)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -142.21, -335.26)",
    filter: "url(#Rectangle_6-2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6-4",
    "data-name": "Rectangle 6",
    width: 714.743,
    height: 23.717,
    rx: 3,
    transform: "translate(142.21 335.26)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Task-2",
    "data-name": "Task",
    transform: "translate(22.639 15.546)",
    fontSize: 8,
    fontFamily: "Lato-Bold, Lato",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Task")), /*#__PURE__*/React.createElement("text", {
    id: "Type-2",
    "data-name": "Type",
    transform: "translate(184.346 15.546)",
    fontSize: 8,
    fontFamily: "Lato-Bold, Lato",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Type")), /*#__PURE__*/React.createElement("text", {
    id: "Document_Name-2",
    "data-name": "Document Name",
    transform: "translate(231.779 15.546)",
    fontSize: 8,
    fontFamily: "Lato-Bold, Lato",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Document Name")), /*#__PURE__*/React.createElement("text", {
    id: "Assigned_To-2",
    "data-name": "Assigned To",
    transform: "translate(356.833 15.546)",
    fontSize: 8,
    fontFamily: "Lato-Bold, Lato",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Assigned To")), /*#__PURE__*/React.createElement("text", {
    id: "Name_of_Employee-2",
    "data-name": "Name of Employee",
    transform: "translate(431.218 15.546)",
    fontSize: 8,
    fontFamily: "Lato-Bold, Lato",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Name of Employee")), /*#__PURE__*/React.createElement("text", {
    id: "Due_Date-2",
    "data-name": "Due Date",
    transform: "translate(530.398 15.546)",
    fontSize: 8,
    fontFamily: "Lato-Bold, Lato",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Due Date")), /*#__PURE__*/React.createElement("text", {
    id: "Action-2",
    "data-name": "Action",
    transform: "translate(610.173 15.546)",
    fontSize: 8,
    fontFamily: "Lato-Bold, Lato",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Action"))), /*#__PURE__*/React.createElement("text", {
    id: "Prepare_welcome_kit",
    "data-name": "Prepare welcome kit",
    transform: "translate(1154.848 294.041)",
    fill: "#707070",
    fontSize: 8,
    fontFamily: "Lato-Bold, Lato",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Prepare welcome kit")), /*#__PURE__*/React.createElement("text", {
    id: "Training",
    transform: "translate(1154.848 465.45)",
    fill: "#707070",
    fontSize: 8,
    fontFamily: "Lato-Bold, Lato",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Training")), /*#__PURE__*/React.createElement("text", {
    id: "Prepare_workspace_software_access",
    "data-name": "Prepare workspace, software, access",
    transform: "translate(1154.848 317.758)",
    fill: "#707070",
    fontSize: 8,
    fontFamily: "Lato-Bold, Lato",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Prepare workspace, software, access")), /*#__PURE__*/React.createElement("text", {
    id: "Meeting_with_HR_manager",
    "data-name": "Meeting with HR manager",
    transform: "translate(1154.848 339.318)",
    fill: "#707070",
    fontSize: 8,
    fontFamily: "Lato-Bold, Lato",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Meeting with HR manager")), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8",
    "data-name": "Rectangle 8",
    width: 714.743,
    height: 30.185,
    rx: 3,
    transform: "translate(1132.209 355.035)",
    fill: "#1c6bfe",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9",
    "data-name": "Rectangle 9",
    width: 714.743,
    height: 30.185,
    rx: 3,
    transform: "translate(1132.209 391.689)",
    fill: "#1c6bfe",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("text", {
    id: "Welcome_Office_Tour_Company_Vision",
    "data-name": "Welcome, Office Tour, Company Vision",
    transform: "translate(1154.848 373.66)",
    fill: "#1c6bfe",
    fontSize: 10,
    fontFamily: "Lato-Bold, Lato",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Welcome, Office Tour, Company Vision")), /*#__PURE__*/React.createElement("text", {
    id: "Paper_Work_-_First_Week_on_the_Job",
    "data-name": "Paper Work - First Week on the Job",
    transform: "translate(1154.848 411.391)",
    fill: "#1c6bfe",
    fontSize: 10,
    fontFamily: "Lato-Bold, Lato",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Paper Work - First Week on the Job")), /*#__PURE__*/React.createElement("text", {
    id: "Employees",
    transform: "translate(1030 240)",
    fill: "#fff",
    fontSize: 9,
    fontFamily: "Lato-Regular, Lato"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Employees")), /*#__PURE__*/React.createElement("text", {
    id: "Employee_xyz",
    "data-name": "Employee xyz",
    transform: "translate(1028 206)",
    fill: "#fff",
    fontSize: 9,
    fontFamily: "Lato-Regular, Lato"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Employee xyz")), /*#__PURE__*/React.createElement("text", {
    id: "Jobs_Offering",
    "data-name": "Jobs Offering",
    transform: "translate(1030 267)",
    fill: "#fff",
    fontSize: 9,
    fontFamily: "Lato-Regular, Lato"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Jobs Offering")), /*#__PURE__*/React.createElement("text", {
    id: "Salary_Payroll",
    "data-name": "Salary & Payroll",
    transform: "translate(1030 318)",
    fill: "#fff",
    fontSize: 9,
    fontFamily: "Lato-Regular, Lato"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Salary &amp; Payroll")), /*#__PURE__*/React.createElement("text", {
    id: "Attendance",
    transform: "translate(1030 344)",
    fill: "#fff",
    fontSize: 9,
    fontFamily: "Lato-Regular, Lato"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Attendance")), /*#__PURE__*/React.createElement("text", {
    id: "Helpdesk",
    transform: "translate(1030 370)",
    fill: "#fff",
    fontSize: 9,
    fontFamily: "Lato-Regular, Lato"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Helpdesk")), /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-check-circle",
    "data-name": "Icon feather-check-circle",
    transform: "translate(1320.867 286.041)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M12.915,7.5v.456A4.958,4.958,0,1,1,9.975,3.42",
    transform: "translate(-3 -2.991)",
    fill: "none",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M19.945,6l-4.958,4.963L13.5,9.475",
    transform: "translate(-10.03 -5.005)",
    fill: "none",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.7
  })), /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-check-circle-2",
    "data-name": "Icon feather-check-circle",
    transform: "translate(1320.867 309.758)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1-2",
    "data-name": "Path 1",
    d: "M12.915,7.5v.456A4.958,4.958,0,1,1,9.975,3.42",
    transform: "translate(-3 -2.991)",
    fill: "none",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2-2",
    "data-name": "Path 2",
    d: "M19.945,6l-4.958,4.963L13.5,9.475",
    transform: "translate(-10.03 -5.005)",
    fill: "none",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.7
  })), /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-check-circle-3",
    "data-name": "Icon feather-check-circle",
    transform: "translate(1320.867 331.319)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1-3",
    "data-name": "Path 1",
    d: "M12.915,7.5v.456A4.958,4.958,0,1,1,9.975,3.42",
    transform: "translate(-3 -2.991)",
    fill: "none",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2-3",
    "data-name": "Path 2",
    d: "M19.945,6l-4.958,4.963L13.5,9.475",
    transform: "translate(-10.03 -5.005)",
    fill: "none",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.7
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3",
    transform: "translate(1741.379 287.119)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_metro-pencil",
    "data-name": "Icon metro-pencil",
    d: "M9.027,1.928a1.2,1.2,0,0,1,.956,1.913L9.5,4.319,7.831,2.645l.478-.478a1.19,1.19,0,0,1,.717-.239Zm-5.978,5.5L2.571,9.58,4.723,9.1,9.146,4.678,7.473,3ZM7.918,4.645,4.57,7.992,4.158,7.58,7.506,4.233Z",
    transform: "translate(24.306 -1.928)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-delete",
    "data-name": "Icon material-delete",
    d: "M7.925,11.3a.853.853,0,0,0,.85.85h3.4a.853.853,0,0,0,.85-.85V6.2h-5.1Zm5.526-6.376H11.963L11.538,4.5H9.413l-.425.425H7.5v.85h5.951Z",
    transform: "translate(66.464 -4.5)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-remove-red-eye",
    "data-name": "Icon material-remove-red-eye",
    d: "M7.111,6.75A6.033,6.033,0,0,0,1.5,10.576a6.028,6.028,0,0,0,11.222,0A6.033,6.033,0,0,0,7.111,6.75Zm0,6.376a2.551,2.551,0,1,1,2.551-2.551A2.551,2.551,0,0,1,7.111,13.126Zm0-4.081a1.53,1.53,0,1,0,1.53,1.53A1.528,1.528,0,0,0,7.111,9.045Z",
    transform: "translate(-1.5 -6.75)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-note",
    "data-name": "Icon material-note",
    d: "M12.565,8.869,9.7,6H3.956A.959.959,0,0,0,3,6.956V12.7a.955.955,0,0,0,.956.952l7.652,0a.955.955,0,0,0,.956-.952ZM9.217,6.717l2.63,2.63H9.217Z",
    transform: "translate(46.581 -6)",
    fill: "#707070"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2",
    transform: "translate(1741.379 310.836)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_metro-pencil-2",
    "data-name": "Icon metro-pencil",
    d: "M9.027,1.928a1.2,1.2,0,0,1,.956,1.913L9.5,4.319,7.831,2.645l.478-.478a1.19,1.19,0,0,1,.717-.239Zm-5.978,5.5L2.571,9.58,4.723,9.1,9.146,4.678,7.473,3ZM7.918,4.645,4.57,7.992,4.158,7.58,7.506,4.233Z",
    transform: "translate(24.306 -1.928)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-delete-2",
    "data-name": "Icon material-delete",
    d: "M7.925,11.3a.853.853,0,0,0,.85.85h3.4a.853.853,0,0,0,.85-.85V6.2h-5.1Zm5.526-6.376H11.963L11.538,4.5H9.413l-.425.425H7.5v.85h5.951Z",
    transform: "translate(66.464 -4.5)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-remove-red-eye-2",
    "data-name": "Icon material-remove-red-eye",
    d: "M7.111,6.75A6.033,6.033,0,0,0,1.5,10.576a6.028,6.028,0,0,0,11.222,0A6.033,6.033,0,0,0,7.111,6.75Zm0,6.376a2.551,2.551,0,1,1,2.551-2.551A2.551,2.551,0,0,1,7.111,13.126Zm0-4.081a1.53,1.53,0,1,0,1.53,1.53A1.528,1.528,0,0,0,7.111,9.045Z",
    transform: "translate(-1.5 -6.75)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-note-2",
    "data-name": "Icon material-note",
    d: "M12.565,8.869,9.7,6H3.956A.959.959,0,0,0,3,6.956V12.7a.955.955,0,0,0,.956.952l7.652,0a.955.955,0,0,0,.956-.952ZM9.217,6.717l2.63,2.63H9.217Z",
    transform: "translate(46.581 -6)",
    fill: "#707070"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    transform: "translate(1741.379 332.397)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_metro-pencil-3",
    "data-name": "Icon metro-pencil",
    d: "M9.027,1.928a1.2,1.2,0,0,1,.956,1.913L9.5,4.319,7.831,2.645l.478-.478a1.19,1.19,0,0,1,.717-.239Zm-5.978,5.5L2.571,9.58,4.723,9.1,9.146,4.678,7.473,3ZM7.918,4.645,4.57,7.992,4.158,7.58,7.506,4.233Z",
    transform: "translate(24.306 -1.928)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-delete-3",
    "data-name": "Icon material-delete",
    d: "M7.925,11.3a.853.853,0,0,0,.85.85h3.4a.853.853,0,0,0,.85-.85V6.2h-5.1Zm5.526-6.376H11.963L11.538,4.5H9.413l-.425.425H7.5v.85h5.951Z",
    transform: "translate(66.464 -4.5)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-remove-red-eye-3",
    "data-name": "Icon material-remove-red-eye",
    d: "M7.111,6.75A6.033,6.033,0,0,0,1.5,10.576a6.028,6.028,0,0,0,11.222,0A6.033,6.033,0,0,0,7.111,6.75Zm0,6.376a2.551,2.551,0,1,1,2.551-2.551A2.551,2.551,0,0,1,7.111,13.126Zm0-4.081a1.53,1.53,0,1,0,1.53,1.53A1.528,1.528,0,0,0,7.111,9.045Z",
    transform: "translate(-1.5 -6.75)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-note-3",
    "data-name": "Icon material-note",
    d: "M12.565,8.869,9.7,6H3.956A.959.959,0,0,0,3,6.956V12.7a.955.955,0,0,0,.956.952l7.652,0a.955.955,0,0,0,.956-.952ZM9.217,6.717l2.63,2.63H9.217Z",
    transform: "translate(46.581 -6)",
    fill: "#707070"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6",
    "data-name": "Group 6",
    transform: "translate(1741.379 459.017)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_metro-pencil-4",
    "data-name": "Icon metro-pencil",
    d: "M9.027,1.928a1.2,1.2,0,0,1,.956,1.913L9.5,4.319,7.831,2.645l.478-.478a1.19,1.19,0,0,1,.717-.239Zm-5.978,5.5L2.571,9.58,4.723,9.1,9.146,4.678,7.473,3ZM7.918,4.645,4.57,7.992,4.158,7.58,7.506,4.233Z",
    transform: "translate(24.306 -1.928)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-delete-4",
    "data-name": "Icon material-delete",
    d: "M7.925,11.3a.853.853,0,0,0,.85.85h3.4a.853.853,0,0,0,.85-.85V6.2h-5.1Zm5.526-6.376H11.963L11.538,4.5H9.413l-.425.425H7.5v.85h5.951Z",
    transform: "translate(66.464 -4.5)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-remove-red-eye-4",
    "data-name": "Icon material-remove-red-eye",
    d: "M7.111,6.75A6.033,6.033,0,0,0,1.5,10.576a6.028,6.028,0,0,0,11.222,0A6.033,6.033,0,0,0,7.111,6.75Zm0,6.376a2.551,2.551,0,1,1,2.551-2.551A2.551,2.551,0,0,1,7.111,13.126Zm0-4.081a1.53,1.53,0,1,0,1.53,1.53A1.528,1.528,0,0,0,7.111,9.045Z",
    transform: "translate(-1.5 -6.75)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-note-4",
    "data-name": "Icon material-note",
    d: "M12.565,8.869,9.7,6H3.956A.959.959,0,0,0,3,6.956V12.7a.955.955,0,0,0,.956.952l7.652,0a.955.955,0,0,0,.956-.952ZM9.217,6.717l2.63,2.63H9.217Z",
    transform: "translate(46.581 -6)",
    fill: "#707070"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3",
    "data-name": "Rectangle 3",
    width: 36.653,
    height: 2.156,
    transform: "translate(1132.209 213.812)",
    fill: "#1c6bfe"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4",
    "data-name": "Rectangle 4",
    width: 697.495,
    height: 1.078,
    transform: "translate(1168.863 214.89)",
    fill: "#1c6bfe",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 990, 92)",
    filter: "url(#Rectangle_5)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5-2",
    "data-name": "Rectangle 5",
    width: 714.743,
    height: 30.185,
    rx: 3,
    transform: "translate(142.21 129.36)",
    fill: "#1c6bfe",
    opacity: 0.1
  })), /*#__PURE__*/React.createElement("text", {
    id: "Before_First_Day",
    "data-name": "Before First Day",
    transform: "translate(1154.848 238.904)",
    fill: "#1c6bfe",
    fontSize: 10,
    fontFamily: "Lato-Bold, Lato",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Before First Day")), /*#__PURE__*/React.createElement("line", {
    id: "Line_1",
    "data-name": "Line 1",
    x2: 715,
    transform: "translate(1131 305)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3",
    "data-name": "Line 3",
    x2: 713.665,
    transform: "translate(1132.748 476.854)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_6",
    "data-name": "Line 6",
    x2: 713.126,
    transform: "translate(1132.748 520.087)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2",
    "data-name": "Line 2",
    x2: 714.743,
    transform: "translate(1131.131 326.523)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_4",
    "data-name": "Line 4",
    x2: 713.126,
    transform: "translate(1132.748 498.471)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_5",
    "data-name": "Line 5",
    x2: 713.126,
    transform: "translate(1132.748 541.703)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7",
    "data-name": "Group 7",
    transform: "translate(1776.88 536.147)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -786.88, -444.15)",
    filter: "url(#Rectangle_11)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11-2",
    "data-name": "Rectangle 11",
    width: 68.995,
    height: 23.717,
    rx: 3,
    transform: "translate(786.88 444.15)",
    fill: "#1c6bfe"
  })), /*#__PURE__*/React.createElement("text", {
    id: "New_Step",
    "data-name": "New Step",
    transform: "translate(3.234 14.468)",
    fill: "#fff",
    fontSize: 8,
    fontFamily: "Lato-Regular, Lato"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "New Step")), /*#__PURE__*/React.createElement("line", {
    id: "Line_7",
    "data-name": "Line 7",
    y2: 15.093,
    transform: "translate(45.817 4.851)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-plus",
    "data-name": "Icon awesome-plus",
    d: "M7.443,5.4H4.866V2.823a.573.573,0,0,0-.573-.573H3.721a.573.573,0,0,0-.573.573V5.4H.573A.573.573,0,0,0,0,5.971v.573a.573.573,0,0,0,.573.573H3.149V9.693a.573.573,0,0,0,.573.573h.573a.573.573,0,0,0,.573-.573V7.116H7.443a.573.573,0,0,0,.573-.573V5.971A.573.573,0,0,0,7.443,5.4Z",
    transform: "translate(51.746 5.296)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M10.139,14.572a.54.54,0,0,0,0,.761l2.668,2.659a.537.537,0,0,0,.742.017l2.629-2.62a.537.537,0,1,0-.758-.761l-2.258,2.225L10.9,14.57A.538.538,0,0,0,10.139,14.572Z",
    transform: "translate(1805.907 220.51)",
    fill: "#0084f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M10.139,14.572a.54.54,0,0,0,0,.761l2.668,2.659a.537.537,0,0,0,.742.017l2.629-2.62a.537.537,0,1,0-.758-.761l-2.258,2.225L10.9,14.57A.538.538,0,0,0,10.139,14.572Z",
    transform: "translate(1805.907 220.51)",
    fill: "#0084f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M.157.159a.54.54,0,0,0,0,.761L2.825,3.58a.537.537,0,0,0,.742.017L6.195.976A.537.537,0,1,0,5.437.215L3.179,2.44.918.156A.538.538,0,0,0,.157.159Z",
    transform: "translate(1817.198 373.283) rotate(-90)",
    fill: "#0084f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M10.139,14.572a.54.54,0,0,0,0,.761l2.668,2.659a.537.537,0,0,0,.742.017l2.629-2.62a.537.537,0,1,0-.758-.761l-2.258,2.225L10.9,14.57A.538.538,0,0,0,10.139,14.572Z",
    transform: "translate(1805.907 391.556)",
    fill: "#0084f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_feather-edit-2",
    "data-name": "Icon feather-edit-2",
    d: "M9.07,3.593a1.145,1.145,0,1,1,1.619,1.619L5.226,10.674,3,11.281l.607-2.226Z",
    transform: "translate(1793.762 229.543)",
    fill: "none",
    stroke: "#0084f4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_feather-edit-2-2",
    "data-name": "Icon feather-edit-2",
    d: "M9.07,3.593a1.145,1.145,0,1,1,1.619,1.619L5.226,10.674,3,11.281l.607-2.226Z",
    transform: "translate(1793.762 362.859)",
    fill: "none",
    stroke: "#0084f4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_feather-edit-2-3",
    "data-name": "Icon feather-edit-2",
    d: "M9.07,3.593a1.145,1.145,0,1,1,1.619,1.619L5.226,10.674,3,11.281l.607-2.226Z",
    transform: "translate(1793.762 400.59)",
    fill: "none",
    stroke: "#0084f4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_12",
    "data-name": "Rectangle 12",
    d: "M3,0H95a0,0,0,0,1,0,0V18a0,0,0,0,1,0,0H3a3,3,0,0,1-3-3V3A3,3,0,0,1,3,0Z",
    transform: "translate(1016 281)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_8",
    "data-name": "Group 8",
    transform: "translate(1600.08 170.69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -610.08, -78.69)",
    filter: "url(#Rectangle_13)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_13-2",
    "data-name": "Rectangle 13",
    width: 22.639,
    height: 12.937,
    rx: 6.468,
    transform: "translate(670.45 78.69)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3",
    "data-name": "Ellipse 3",
    cx: 5.39,
    cy: 5.39,
    r: 5.39,
    transform: "translate(71.151 1.078)",
    fill: "#0084f4"
  }), /*#__PURE__*/React.createElement("text", {
    id: "Switch_to_hidden",
    "data-name": "Switch to hidden",
    transform: "translate(0 8.156)",
    fill: "#0084f4",
    fontSize: 6,
    fontFamily: "Lato-Regular, Lato"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Switch to hidden"))), /*#__PURE__*/React.createElement("text", {
    id: "Onboarding-3",
    "data-name": "Onboarding",
    transform: "translate(1030 292)",
    fill: "#1c6bfe",
    fontSize: 9,
    fontFamily: "Lato-Regular, Lato"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Onboarding")), /*#__PURE__*/React.createElement("g", {
    id: "Group_9",
    "data-name": "Group 9",
    transform: "translate(1700.338 166.378)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_14",
    "data-name": "Rectangle 14",
    width: 146.614,
    height: 21.561,
    rx: 2,
    fill: "#1c6bfe"
  }), /*#__PURE__*/React.createElement("text", {
    id: "Back_to_Workflows",
    "data-name": "Back to Workflows",
    transform: "translate(14.015 13.39)",
    fill: "#fff",
    fontSize: 8,
    fontFamily: "Lato-Regular, Lato"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Back to Workflows")), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M.157.159a.54.54,0,0,0,0,.761L2.825,3.58a.537.537,0,0,0,.742.017L6.195.976A.537.537,0,1,0,5.437.215L3.179,2.44.918.156A.538.538,0,0,0,.157.159Z",
    transform: "translate(129.796 13.9) rotate(-90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_8",
    "data-name": "Line 8",
    y2: 16.171,
    transform: "translate(118.046 2.695)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10",
    "data-name": "Group 10",
    transform: "translate(1110.523 99)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -120.52, -7)",
    filter: "url(#Rectangle_15)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_15-2",
    "data-name": "Rectangle 15",
    d: "M0,0H732a25,25,0,0,1,25,25V44a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V0A0,0,0,0,1,0,0Z",
    transform: "translate(121 7)",
    fill: "#f3f9fe"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_16",
    "data-name": "Rectangle 16",
    transform: "translate(19.477 11)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 0.2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 400,
    height: 22,
    rx: 3,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.1,
    y: 0.1,
    width: 399.8,
    height: 21.8,
    rx: 2.9,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Search_for...",
    "data-name": "Search for...",
    transform: "translate(55.477 25)",
    fill: "#707070",
    fontSize: 9,
    fontFamily: "Lato-Regular, Lato"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Search for...")), /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-md-search",
    "data-name": "Icon ionic-md-search",
    d: "M11.741,10.89h-.463l-.174-.145A3.845,3.845,0,0,0,12,8.276a3.751,3.751,0,1,0-3.737,3.776,3.882,3.882,0,0,0,2.462-.9l.174.145v.465l2.9,2.9.869-.871Zm-3.476,0a2.614,2.614,0,1,1,2.607-2.614A2.6,2.6,0,0,1,8.265,10.89Z",
    transform: "translate(29.045 13.346)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("text", {
    id: "March_8_2023_4:30_PM",
    "data-name": "March 8, 2023, 4:30 PM",
    transform: "translate(634.477 25)",
    fill: "#707070",
    fontSize: 8,
    fontFamily: "Lato-Regular, Lato"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "March 8, 2023, 4:30 PM"))), /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-computer",
    "data-name": "Icon material-computer",
    d: "M14.965,16.476a1.5,1.5,0,0,0,1.489-1.5L16.462,7.5a1.5,1.5,0,0,0-1.5-1.5H2.993A1.5,1.5,0,0,0,1.5,7.5v7.483a1.5,1.5,0,0,0,1.5,1.5H0v1.5H17.958v-1.5ZM2.993,7.5H14.965v7.483H2.993Z",
    transform: "translate(1316.2 452.528)",
    fill: "#707070"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnboarding);
export default __webpack_public_path__ + "static/media/Onboarding.09dfaf5ee2712512a6b72a74bca5509c.svg";
export { ForwardRef as ReactComponent };